import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { DeviceProvider } from './contexts/DeviceContext';
import PhotoUploader from './components/PhotoUploader';
import { FlowApp } from './flow/FlowApp';
import { breakfastTheme } from './theme/BreakfastTheme';
import './App.css';

function hasLegacyUploadLink(): boolean {
  const params = new URLSearchParams(window.location.search);
  return Boolean(params.get('id')?.trim() && params.get('key')?.trim());
}

function App() {
  const legacyUploadLink = hasLegacyUploadLink();

  return (
    <DeviceProvider>
      <ThemeProvider theme={breakfastTheme}>
        <CssBaseline />
        <BrowserRouter>
          {legacyUploadLink ? <PhotoUploader /> : <FlowApp />}
        </BrowserRouter>
      </ThemeProvider>
    </DeviceProvider>
  );
}

export default App;
